exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.active > .variantMultiple[data-v-ae2c9902] {\n    color: white;\n}\n.variantMultiple[data-v-ae2c9902] {\n    margin-right: 4px;\n}\n", ""]);

// exports
